import { MdOutlineCalendarMonth } from "react-icons/md";

export default function CalendarIcon({size}) {
    return <MdOutlineCalendarMonth size={size} />;
}